import { z } from "zod";

export const groupFormSchema = z.object({
  name: z.string().min(1, "Name is required").max(100),
  time_of_day: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/, "Time must be HH:MM"),
  days_of_week: z
    .array(z.number().int().min(1).max(7))
    .min(1, "Pick at least one day"),
  sites: z.array(z.string()),
  enabled: z.boolean(),
});

export type GroupFormType = z.infer<typeof groupFormSchema>;
